import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Password from "../Login/Password";
import { puedeModulo } from "../../../permisos/permisos";

// ── Navegación completa (usuarios internos) ───────────────────────────────────
const NAV_FULL = [
    {
    section: "Comercial",
    items: [
      { label: "CRM", icon: "fas fa-bullseye", href: "/MenuCrm", modulo: "crm" },
    ],
  },
  {
    section: "Operación",
    items: [
      { label: "Catálogos",   icon: "fas fa-box",          href: "/MenuCatalogos",   modulo: "catalogos"   },
      { label: "Compras",     icon: "fas fa-truck",        href: "/MenuCompras",     modulo: "compras"     },
      { label: "Producción",  icon: "fas fa-wine-bottle",  href: "/MenuPlasticos",   modulo: "produccion"  },
      { label: "Inventarios", icon: "fas fa-warehouse",    href: "/MenuInventarios", modulo: "inventarios" },
      { label: "Ventas",     icon: "fas fa-clipboard-list", href: "/MenuVentas",     modulo: "ventas"      },
    ],
  },

  {
    section: "Finanzas",
    items: [
      { label: "Admin",  icon: "fas fa-file-invoice-dollar", href: "/MenuAdmin", modulo: "admin"    },
      { label: "CxP",    icon: "fas fa-money-check-alt",     href: "/MenuCXP",   modulo: "cxp" },
      { label: "Fiscal", icon: "fas fa-file-invoice",        href: "/MenuFiscal", modulo: "fiscal"  },
      { label: "Gastos", icon: "fas fa-wallet",              href: "/MenuGastos", modulo: "gastos"  },
    ],
  },
  {
    section: "Personal",
    items: [
      { label: "Empleados", icon: "fas fa-id-badge", href: "/MenuNominas", modulo: "empleados" },
    ],
  },
  {
    section: "Sistema",
    items: [
      { label: "Usuarios", icon: "fas fa-user-cog",       href: "/MenuUsuarios", modulo: "usuarios" },
      { label: "Logs",     icon: "fas fa-clipboard-check", href: "/MenuLogs",    modulo: "logs"     },
    ],
  },
];

// ── Navegación limitada (cobradores / clientes) ───────────────────────────────
const NAV_LIMITED = [
  {
    section: "Mi cuenta",
    items: [
      { label: "Abonos Facturas",  icon: "fas fa-hand-holding-usd", href: "/AbonosNotasCreate",   perm: "menu_cobradores"    },
      { label: "Estado de Cuenta", icon: "fas fa-file-alt",         href: "/EdoCtaVistaFamilias", perm: "menu_edoCta_Fam"    },
      { label: "Info Alumnos",     icon: "fas fa-user-graduate",    href: "/InfoHijos",           perm: "menu_edoCta_Fam"    },
      { label: "Estado de Cuenta", icon: "fas fa-file-alt",         href: "/EdoCtaVistaClientes", perm: "menu_edoCta_Cliente" },
    ],
  },
];

const Header = () => {
  const { isAuth, user } = useContext(AuthContext);

  const [sidebarOpen,   setSidebarOpen]   = useState(false);
  const [modalPassword, setModalPassword] = useState(false);
  const [userMenuOpen,  setUserMenuOpen]  = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar-collapsed") === "true"
  );

  const currentPath = window.location.pathname;

  // ── Body classes ──────────────────────────────────────────────────────────
  useEffect(() => {
    if (!isAuth) return;
    document.body.classList.add("has-sidebar");
    if (localStorage.getItem("sidebar-collapsed") === "true") {
      document.body.classList.add("sidebar-collapsed");
    }
    return () => {
      document.body.classList.remove("has-sidebar");
      document.body.classList.remove("sidebar-collapsed");
    };
  }, [isAuth]); // eslint-disable-line

  if (!isAuth) return null;

  // Usuarios de portal (cobrador / cliente) usan la navegación limitada
  const isPortal = user.menu_edoCta_Cliente || user.menu_cobradores;
  const NAV_SECTIONS = isPortal ? NAV_LIMITED : NAV_FULL;

  // ── Helpers ───────────────────────────────────────────────────────────────
  // Modulos: se ven si el usuario ve al menos una de sus pantallas (catalogo de permisos).
  const hasPerm = (item) => (item.modulo ? puedeModulo(user, item.modulo) : !!user[item.perm]);

  const toggleCollapse = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebar-collapsed", next);
    if (next) {
      document.body.classList.add("sidebar-collapsed");
      setUserMenuOpen(false);
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  };

  return (
    <>
      {/* ── Mobile top bar ──────────────────────────────────────────────── */}
      <div className="sidebar-topbar d-lg-none">
        <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
          <i className="fas fa-bars" />
        </button>
        <a href="/Inicio">
          <img src={process.env.PUBLIC_URL + "/LogoInstitucion.png"} height="34" alt="logo" />
        </a>
      </div>

      {/* ── Mobile overlay ──────────────────────────────────────────────── */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* ── Sidebar ─────────────────────────────────────────────────────── */}
      <aside
        className={[
          "app-sidebar",
          sidebarOpen ? "open"      : "",
          collapsed   ? "collapsed" : "",
        ].filter(Boolean).join(" ")}
      >
        {/* Brand */}
        <div className="sidebar-brand">
          <a href="/Inicio" className="sidebar-logo-link">
            <img
              src={process.env.PUBLIC_URL + "/LogoInstitucion.png"}
              alt="logo"
              style={{ maxHeight: 44, width: "auto" }}
            />
          </a>
          <button
            className="sidebar-collapse-btn"
            onClick={toggleCollapse}
            title={collapsed ? "Expandir" : "Comprimir"}
          >
            <i className={`fas fa-chevron-${collapsed ? "right" : "left"}`} />
          </button>
        </div>

        {/* Nav */}
        <nav className="sidebar-nav">
          {NAV_SECTIONS.map((sec) => {
            const visibleItems = sec.items.filter((i) => hasPerm(i));
            if (visibleItems.length === 0) return null;

            return (
              <div key={sec.section} className="sidebar-section-group">
                <div className="sidebar-section">{sec.section}</div>

                {visibleItems.map((item) => {
                  const isActive = currentPath === item.href;
                  return (
                    <a
                      key={item.href}
                      href={item.href}
                      className={`sidebar-item${isActive ? " active" : ""}`}
                      title={collapsed ? item.label : ""}
                    >
                      <i className={item.icon} />
                      <span className="sidebar-label">{item.label}</span>
                    </a>
                  );
                })}
              </div>
            );
          })}
        </nav>

        {/* User footer */}
        <div className="sidebar-footer">
          <div
            className="sidebar-item"
            onClick={() => !collapsed && setUserMenuOpen(!userMenuOpen)}
            title={collapsed ? (user.nombre || user.email || "Usuario") : ""}
            style={{ justifyContent: collapsed ? "center" : "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
              <i className="fas fa-user-circle" />
              <span className="sidebar-label" style={{ fontSize: "0.78rem" }}>
                {user.nombre || user.email || "Usuario"}
              </span>
            </div>
            {!collapsed && (
              <i className={`fas fa-chevron-${userMenuOpen ? "down" : "up"} fa-xs`} style={{ opacity: 0.5 }} />
            )}
          </div>

          {userMenuOpen && !collapsed && (
            <div className="sidebar-submenu">
              <div
                className="sidebar-item sidebar-item-sm"
                onClick={() => { setModalPassword(true); setUserMenuOpen(false); }}
              >
                <i className="fas fa-lock" />
                <span>Cambiar contraseña</span>
              </div>
              <a href="/logout" className="sidebar-item sidebar-item-sm" style={{ color: "#f87171" }}>
                <i className="fas fa-sign-out-alt" />
                <span>Cerrar sesión</span>
              </a>
            </div>
          )}
        </div>
      </aside>

      {/* ── Password modal ───────────────────────────────────────────────── */}
      <Modal size="sm" isOpen={modalPassword} toggle={() => setModalPassword(false)}>
        <ModalHeader toggle={() => setModalPassword(false)}>
          Cambio de contraseña
        </ModalHeader>
        <ModalBody>
          <Password />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Header;
